var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-edit',_vm._g(_vm._b({attrs:{"name":"projects-edit","title":_vm.projectName,"toptitle":_vm.$t('projects.form.edit')}},'base-edit',_vm.$attrs,false),_vm.$listeners),[_c('projects-form',{attrs:{"project":_vm.project,"type":"edit"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }